import { render, staticRenderFns } from "./UpdateCategory.vue?vue&type=template&id=d8eb1594"
import script from "./UpdateCategory.vue?vue&type=script&lang=js"
export * from "./UpdateCategory.vue?vue&type=script&lang=js"
import style0 from "./UpdateCategory.vue?vue&type=style&index=0&id=d8eb1594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports